import { Component, Input, SimpleChanges } from '@angular/core';
import { PracticeChartComponent } from './practice-chart/practice-chart.component';
import { PracticeTableComponent } from './practice-table/practice-table.component';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';
import { TranslationService } from 'src/app/services/translation.service';
import { CommonModule } from '@angular/common';
import { QaiLoadingComponent } from '@qai/ui';
import { AssignmentCategory, IPracticeAssignmentStatsRequest } from 'src/app/interfaces/reportingV2/ipractice-assignment-stats-request';
import { IPracticeAssignmentStatsResponse } from 'src/app/interfaces/reportingV2/ipractice-assignment-stats-response';
import { ReportingDashboardService } from 'src/app/services/reporting-dashboard/reporting-dashboard.service';
import { AssignmentFilterComponent } from '../assignment-filter/assignment-filter.component';
import { withDemoModule } from 'src/app/utils/demo-mode/demo-mode-context.util';
import { AppConstants } from 'src/app/app-constants';


@Component({
  selector: 'app-practice-tab',
  templateUrl: './practice-tab.component.html',
  styleUrls: ['./practice-tab.component.scss'],
  standalone: true,
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'reportingV2',
    },
  ],
  imports: [
    PracticeChartComponent,
    PracticeTableComponent,
    TranslocoModule,
    CommonModule,
    QaiLoadingComponent,
    AssignmentFilterComponent
  ],
})
export class PracticeTabComponent {
  @Input() selectedAccount: { label: string; value: string } | null = null;
  @Input() selectedTeams: string[] = [];

  isTranslationLoaded: boolean = false;
  isLoading: boolean = true;
  isNetworkCallInprogress: boolean = false;
  practiceAssignmentStats: IPracticeAssignmentStatsResponse[] = [];
  visiblePracticeAssignments: IPracticeAssignmentStatsResponse[] = [];
  currentFilter: AssignmentCategory = 'RECENT_ASSIGNMENTS';

  constructor(
    private translationService: TranslationService,
    private reportingDashboardService: ReportingDashboardService
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (this.isTranslationLoaded && (changes['selectedAccount'] || changes['selectedTeams'])) {
      this.loadPracticeAssignmentStats();
    }
  }

  ngOnInit() {
    this.translationService.loadScopedTranslation('reportingV2').then(() => {
      this.isTranslationLoaded = true;
      this.isLoading = false;
    });
  }

  onVisibleAssignmentsChanged(visibleAssignments: IPracticeAssignmentStatsResponse[]): void {
    this.visiblePracticeAssignments = visibleAssignments;
  }

  onAssignmentChange(event: string): void {
    this.currentFilter = event as AssignmentCategory;
    this.loadPracticeAssignmentStats();
  }


  loadPracticeAssignmentStats() {
    if (!this.selectedAccount?.value) {
      console.warn('No account selected');
      return;
    }

    this.isNetworkCallInprogress = true;

    const teamUuids = this.selectedTeams.includes('all')
      ? []
      : this.selectedTeams;

    const payload: IPracticeAssignmentStatsRequest = {
      accountUuid: this.selectedAccount.value,
      teamUuids: teamUuids,
      category: this.currentFilter,
    };

    this.reportingDashboardService
      .getPracticeAssignmentStats(payload, withDemoModule(AppConstants.NEW_REPORTING_UI))
      .subscribe({
        next: (response) => {
          this.practiceAssignmentStats = response;
          this.isNetworkCallInprogress = false;
          console.log('Practice stats loaded:', response);
        },
        error: (error) => {
          console.error('Error loading practice stats:', error);
          this.isNetworkCallInprogress = false;
          this.practiceAssignmentStats = [];
          this.visiblePracticeAssignments = [];
        },
      });
    }}